import PropTypes from 'prop-types'

/**
 * @typedef {string|(params: Object.<string, any>) => string} ComponentTranslation
 */
export const componentTranslationPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func])

/**
 * @description This function generates the proper proptypes for a component based on its translation map.
 *
 * @param {Object.<string, {stringCode: string, fallback: string, parameters?: string[]}>} translationMap -
 * a record listing all required translations and their defintion object.
 *
 * @returns {Object.<string, PropType>} an Object that maps each key of the translationMap to its PropType
 */
export function createTranslationPropTypesFromTranslationMap(translationMap) {
    return Object.keys(translationMap).reduce((translationPropTypes, translationProp) => {
        translationPropTypes[translationProp] = translationMap[translationProp].parameters?.length
            ? PropTypes.func
            : PropTypes.string

        return translationPropTypes
    }, {})
}
